module.exports = __webpack_public_path__ + "img/logo_img.296beeb1.png";